import { useEffect, useRef, useState } from "react";
import { BookOpen, Unlock } from "lucide-react";
import { Button } from "@/components/ui/button";

const HOTMART_CHECKOUT_URL = "https://pay.hotmart.com/X103718093T?checkoutMode=10";
const FlipbookSection = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !isLoaded) {
        iframe.src = "https://online.anyflip.com/frlvw/svua/index.html";
        setIsLoaded(true);
        observer.disconnect();
      }
    }, {
      rootMargin: "300px"
    });
    observer.observe(iframe);
    return () => observer.disconnect();
  }, [isLoaded]);
  return <section className="relative overflow-hidden section-padding gradient-hero">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} />
      </div>
      <div className="container-centered relative z-10">
        {/* Section Header */}
        <div className="mb-10 text-center">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-2">
            <BookOpen className="h-5 w-5 text-primary" />
            <span className="text-sm font-semibold text-primary">Vista Previa</span>
          </div>
          <h2 className="font-display text-2xl font-bold text-foreground sm:text-3xl lg:text-4xl">
            Mira Por Dentro{" "}
            <span className="text-primary">Antes de Comprar</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-secondary-foreground">Explora algunas páginas del sistema para ver la calidad del contenido 
📘 Estas son páginas reales del sistema que recibirás. Sin relleno. Sin promesas vacías. Contenido práctico y accionable.</p>
        </div>

        {/* AnyFlip Flipbook Embed - Lazy loaded for performance */}
        <div className="mx-auto max-w-3xl">
          <div className="relative overflow-hidden rounded-2xl shadow-card bg-card min-h-[450px] sm:min-h-[500px] lg:min-h-[550px]">
            {!isLoaded && <div className="absolute inset-0 flex items-center justify-center bg-card">
                <div className="text-center">
                  <BookOpen className="h-12 w-12 text-primary/50 mx-auto mb-2 animate-pulse" />
                  <p className="text-muted-foreground text-sm">Cargando vista previa...</p>
                </div>
              </div>}
            <iframe ref={iframeRef} style={{
            width: "100%",
            height: "450px"
          }} src="about:blank" seamless scrolling="no" frameBorder="0" allowTransparency allowFullScreen title="Vista previa del ebook" className="sm:h-[500px] lg:h-[550px]" />
          </div>
          
          {/* CTA Button */}
          <div className="mt-8 text-center">
            <Button
              onClick={() => window.open(HOTMART_CHECKOUT_URL, "_blank")}
              size="lg"
              className="h-auto min-h-14 w-full sm:w-auto bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 px-6 sm:px-12 py-3 text-sm sm:text-lg font-bold text-slate-900 shadow-lg transition-all hover:scale-105 hover:opacity-90 whitespace-normal text-center"
            >
              <Unlock className="mr-2 h-5 w-5 flex-shrink-0" />
              <span>Quiero Acceso Inmediato – $16.99</span>
            </Button>
          </div>
        </div>
      </div>
    </section>;
};
export default FlipbookSection;